<formio  [form]='formSchema' class="zsd-formio" formControlName='formioform' 
(change)="onchange($event)" 
(render)="onrender(formSchema)"
(errorChange)="onError()"
(submit)="onSubmit()"
[attr.id]="'formio' + id"
[options]="{
    i18n: {
        en: {
            required : getLocalizedString('errorRequired'),
            error : getLocalizedString('error'),
            invalid_date :getLocalizedString('invalidDate'),
            invalid_email : getLocalizedString('invalidEmail'),
            invalid_regex : getLocalizedString('invalidRegex'),
            invalid_url: getLocalizedString('invalidUrl'),
            invalid_day: getLocalizedString('invalidDay'),
            mask : getLocalizedString('mask'),
            max : getLocalizedString('max'),
            maxLength : getLocalizedString('maxLength'),
            min : getLocalizedString('min'),
            minLength : getLocalizedString('minLength'),
            next : getLocalizedString('next'),
            pattern : getLocalizedString('pattern'),
            previous : getLocalizedString('previous'),
            minWords: getLocalizedString('minWords'),
            maxWords: getLocalizedString('maxWords'),
            minSelectedCount: getLocalizedString('minSelectedCount'),
            maxSelectedCount: getLocalizedString('maxSelectedCount'),
            maxDate: getLocalizedString('maxDate'),
            minDate: getLocalizedString('minDate')
         }
        }
    }"
>
</formio> 
